export default __webpack_public_path__ + "static/avatar2-d9eb24eef0c7636b236d1f96867b751e.jpg";